// extracted by mini-css-extract-plugin
export var action = "TopBar-module--action--2f7cd";
export var badge = "TopBar-module--badge--1f551";
export var icon = "TopBar-module--icon--22f45";
export var leading = "TopBar-module--leading--feb1f";
export var root = "TopBar-module--root--14402";
export var trailing = "TopBar-module--trailing--352b6";